module.exports = "<app-principal>\r\n</app-principal>"